
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { usePicwordPetList } from '@/modules/picword/pet/model/list';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.PET.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = usePicwordPetList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Total level', key: 'totalLevel' },
                { type: TableColumnType.Text, label: 'Interactive seconds', key: 'interactiveSeconds' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_PICWORD.PET.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PICWORD.PET.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_PICWORD };
    }
});
